export default __webpack_public_path__ + "i18n/translations/translation-de.fa3bb4f7.json";